import api from './api';

export type A11yImpact = 'critical' | 'serious' | 'moderate' | 'minor' | 'info';

export interface A11yRouteSummary {
  pageRoute: string;
  open: number;
  critical: number;
  serious: number;
  moderate: number;
  minor: number;
}

export interface A11yTopRule {
  ruleId: string;
  ruleDescription: string;
  openCount: number;
}

export interface A11ySummary {
  environment: 'dev' | 'staging' | 'prod';
  generatedAt: string;
  totals: {
    open: number;
    critical: number;
    serious: number;
    moderate: number;
    minor: number;
  };
  byRoute: A11yRouteSummary[];
  topRules: A11yTopRule[];
}

export interface A11yIssue {
  _id: string;
  scanId: string;
  pageRoute: string;
  ruleId: string;
  ruleDescription: string;
  impact: A11yImpact;
  tags: string[];
  htmlSnippet?: string;
  target: string[];
  helpUrl?: string;
  status: 'open' | 'in-progress' | 'fixed' | 'ignored';
  firstDetectedAt: string;
  lastDetectedAt: string;
  notes?: string;
}

export interface A11yIssuesResponse {
  issues: A11yIssue[];
  total: number;
  page: number;
  limit: number;
}

const a11yService = {
  async getSummary(
    environment: 'dev' | 'staging' | 'prod' = 'staging'
  ): Promise<A11ySummary> {
    const { data } = await api.get<{ success: boolean; data: A11ySummary }>(
      '/a11y/summary',
      { params: { environment } }
    );
    return data.data;
  },

  async getIssues(params: {
    route?: string;
    impact?: A11yImpact;
    status?: 'open' | 'in-progress' | 'fixed' | 'ignored';
    environment?: 'dev' | 'staging' | 'prod';
    page?: number;
    limit?: number;
  }): Promise<A11yIssuesResponse> {
    const { data } = await api.get<{
      success: boolean;
      data: A11yIssuesResponse;
    }>('/a11y/issues', {
      params,
    });
    return data.data;
  },
};

export default a11yService;
